import { Component, OnInit, Inject } from '@angular/core';
import { _ } from '@icc/shared/helpers';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DoorSlat } from '@icc/window-door/types';
import { PageComponent, SharedFacade, ICC_PAGE_DATA } from '@icc/configurator/shared';


@Component({
    selector: 'icc-slats',
    templateUrl: './slats.component.html',
    styleUrls: ['./slats.component.scss'],
    standalone: false
})
export class SlatsComponent extends PageComponent implements OnInit {
    public title = _('DOOR|Lamele');

    slat: DoorSlat | null = null;
    slatSpace: {sashSlatSpace: number, maxSlatCount: number, currentSlatCount?: number} | null = null;
    slatCount = 1;
    slatForm: UntypedFormGroup;
    slatImage: string;

    constructor(
        private sharedFacade: SharedFacade,
        private fb: UntypedFormBuilder,
        @Inject(ICC_PAGE_DATA) private pageData: {
            slat: DoorSlat,
            slatSpace: {sashSlatSpace: number, maxSlatCount: number, currentSlatCount?: number}
        }
    ) {
        super();
    }

    ngOnInit() {
        this.slat = this.pageData.slat;
        this.slatSpace = this.pageData.slatSpace;
        this.slatImage = "/files/slat/" + this.slat.image;
        this.slatForm = this.fb.group({
            slatCount: [
              this.slatSpace.currentSlatCount || 1,
              [
                Validators.required,
                Validators.min(1),
                Validators.max(this.slatSpace.maxSlatCount)
              ]
            ]
          });
    }

    close() {
        this.sharedFacade.closePage({
            slat: this.slat,
            slatSpace: this.slatSpace,
            slatCount: this.slatForm.get('slatCount').value,
        });
    }
}
